"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedRichText = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
function ExtendedRichText({ customId, className, textAlign, lightText, backgroundColor, fullWidthBg, children, }) {
    return (react_1.default.createElement("div", { id: customId, className: (0, classnames_1.default)('extended-rte', {
            'text-white light': lightText,
        }), style: fullWidthBg ? { backgroundColor } : {} },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(className), style: {
                textAlign,
                backgroundColor: fullWidthBg ? 'none' : backgroundColor,
            } },
            react_1.default.createElement("div", { className: "custom-rich-text w-full after:content-[''] after:w-full after:table after:clear-both" }, children))));
}
exports.ExtendedRichText = ExtendedRichText;
